import React from 'react';
import { Web3Context } from '../contexts/Web3Context'

export default () => React.useContext(Web3Context);
